import Vue from "vue";
import Router from "vue-router";
import OnhbSubscription from "./views/OnhbSubscription";
import NothingButFlowers from "./views/NothingButFlowers";
import MovieAccentExpertBreaksDown from "./views/MovieAccentExpertBreaksDown";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/inscricoes/:subsSlug/:step/:process?",
      name: "nothingButFlowers",
      component: NothingButFlowers,
      meta: {
        title: "Inscrições em programas da ONHB"
      }
    },
    {
      path: "/MovieAccentExpertBreaksDown",
      name: "movieAccentExpertBreaksDown",
      component: MovieAccentExpertBreaksDown,
      meta: {
        title: "Inscrições na Pré-ONHB"
      }
    }
  ]
});
